/* eslint-disable */
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 5,
    justifyContent: 'center'
  },
  icon : {marginLeft: 10 , color : '#d3d3d3' }
})
